import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { MinimalProgressBar } from "@circle-react-uikit/MinimalProgressBar";
import { Typography } from "@circle-react-uikit/Typography";

export const ExtraStorageBillingDetails = () => {
  const { currentCommunity } = usePunditUserContext();

  if (!currentCommunity?.growth_storage_billing_enabled) {
    return null;
  }

  // Hardcoded values based on mock
  const storageUsed = 1.0484;
  const storageTotal = 1.5;
  const addOnStorage = 50;
  const progress = (storageUsed / storageTotal) * 100;
  const price = "$10";

  return (
    <div className="bg-primary border-primary my-6 rounded-lg border px-8 py-7">
      <div className="border-primary mb-6 flex justify-between border-b pb-6">
        <div className="flex items-center gap-2">
          <Typography.TitleSm weight="bold" data-testid="extra-storage-title">
            {t("settings.billing.extra_storage.title")}
          </Typography.TitleSm>
        </div>
        <Typography.TitleSm weight="bold" data-testid="extra-storage-price">
          {price}
        </Typography.TitleSm>
      </div>

      <div>
        <div className="mb-4">
          <Typography.LabelMd weight="semibold">
            {t("settings.billing.extra_storage.storage_limit")}
          </Typography.LabelMd>
        </div>
        <div className="mb-2">
          <MinimalProgressBar progress={progress} size="sm" />
        </div>
        <div className="flex justify-between">
          <Typography.LabelSm color="text-light">
            {t("settings.billing.extra_storage.storage_usage", {
              used: storageUsed,
              total: storageTotal,
              addon: addOnStorage,
            })}
          </Typography.LabelSm>
        </div>
      </div>
    </div>
  );
};
